import { http } from "@/lib/http";
export function fetchNewsEvents() {
  return http.get("/api/news-events").then((res) => res.data);
}
export function fetchNewsEvent(id) {
  return fetchNewsEvents().then(
    (list) => list.find((n) => n._id === id) ?? null,
  );
}
export function addNewsEvent(payload) {
  return http.post("/api/news-events/add", payload).then((res) => res.data);
}
export function saveNewsEvent(payload) {
  return http.post("/api/news-events/save", payload).then((res) => res.data);
}
export function deleteNewsEvent(id) {
  return http.post("/api/news-events/delete", { id }).then((res) => res.data);
}
